<kodit-page>
  <kodit-table [tableConfig]="tableConfig" [items]="korisniciTable">
  </kodit-table>
</kodit-page>
